import { create } from 'zustand';
import type { AdminUser, Settings } from '@/types';

interface AppStore {
  user: AdminUser | null;
  settings: Settings | null;
  sidebarOpen: boolean;
  theme: 'light' | 'dark';
  
  // User actions
  setUser: (user: AdminUser | null) => void;
  
  // Settings actions
  setSettings: (settings: Settings) => void;
  
  // UI actions
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  setTheme: (theme: 'light' | 'dark') => void;
  toggleTheme: () => void;
  
  // Logout
  logout: () => void;
}

export const useAppStore = create<AppStore>((set) => ({
  user: null,
  settings: null,
  sidebarOpen: true,
  theme: 'light',

  setUser: (user) => set({ user }),
  
  setSettings: (settings) => set({ settings }),
  
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  
  setTheme: (theme) => {
    set({ theme });
    if (typeof window !== 'undefined') {
      localStorage.setItem('theme', theme);
      document.documentElement.setAttribute('data-theme', theme);
    }
  },
  
  toggleTheme: () =>
    set((state) => {
      const newTheme = state.theme === 'light' ? 'dark' : 'light';
      if (typeof window !== 'undefined') {
        localStorage.setItem('theme', newTheme);
        document.documentElement.setAttribute('data-theme', newTheme);
      }
      return { theme: newTheme };
    }),
  
  logout: () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('token');
    }
    set({ user: null, sidebarOpen: true });
  },
}));
